module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/black-end-quote-626bc397b3e6d2f6da9f998f215e8f23.png";